import React, { useState, useEffect, useContext } from 'react';

const ThemeContext = React.createContext('light');

export function ThemeProvider2({ children }) {
  // useState
  const [theme, setTheme] = useState(global.window?.__theme || 'light');
  // functions
  const toggleTheme = () => {
    global.window.__setPreferredTheme(theme === 'light' ? 'dark' : 'light');
  };

  // useEffect
  useEffect(() => {
    global.window.__onThemeChange = setTheme;
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
